import { GoalFormLinks, ID, NewGoal, RelationshipUpdate } from '@griply/types';

import { buildGoalLinkWrites } from './build-goal-link-writes';
import { buildGoalParentLinkWrites } from './build-goal-parent-link-writes';

// Carried by the create write itself — the rules reject a 2nd write to the document within 100ms.
export const getNewGoalLinkFlags = ({
  parentIds,
  lifeAreaIds,
}: GoalFormLinks): Pick<
  NewGoal,
  'parentLinksMigrated' | 'lifeAreaLinksMigrated'
> => ({
  ...(parentIds.length ? { parentLinksMigrated: true } : {}),
  ...(lifeAreaIds.length ? { lifeAreaLinksMigrated: true } : {}),
});

// The relationship doc for a goal that was just created with the flags above: nothing to diff against.
export const buildCreatedGoalLinkWrites = (
  goalId: ID,
  { parentIds, lifeAreaIds }: GoalFormLinks,
): RelationshipUpdate[] => [
  ...buildGoalLinkWrites({
    goalId,
    lifeAreaIds,
    currentLifeAreaIds: [],
    isMigrated: true,
  }).relationshipUpdates,
  ...buildGoalParentLinkWrites({
    goalId,
    parentIds,
    currentParentIds: [],
    // Nothing hangs under a goal that was just created.
    subtreeIds: new Set([goalId]),
    isMigrated: true,
  }).relationshipUpdates,
];
